export default [
  'Date',
  'Relevance'
]

export const defaultSort = 'Date'
